import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRocket = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.285 19.667c-.249.399-.37.864-.35 1.333M4.336 15.718a2.28 2.28 0 0 1-1.333.34M10.239 7.031l-4.251.331-1.82 1.82a30 30 0 0 1 3.29 2.236 29.4 29.4 0 0 1 5.125 5.127 31 31 0 0 1 2.237 3.278l1.81-1.81.33-4.26"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.185 11.943a22.9 22.9 0 0 1 3.512-5.428s4.757-5.067 9.815-3.034c2.042 4.942-3.025 9.815-3.025 9.815a23 23 0 0 1-5.438 3.521 8.8 8.8 0 0 1-2.004.749l-3.618-3.619q.31-1.028.758-2.004"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M14.248 11.136a1.342 1.342 0 1 0 0-2.684 1.342 1.342 0 0 0 0 2.684M14.716 4.035l5.252 5.253M6.155 17.858l-1.05 1.04"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRocket);
export default ForwardRef;
